module.exports = __webpack_public_path__ + "img/J＆G Fried Chicken.d3f2fdaa.svg";